import { render, staticRenderFns } from "./tip_values.vue?vue&type=template&id=4a97a2d0&scoped=true&"
import script from "./tip_values.vue?vue&type=script&lang=js&"
export * from "./tip_values.vue?vue&type=script&lang=js&"
import style0 from "./tip_values.vue?vue&type=style&index=0&id=4a97a2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97a2d0",
  null
  
)

export default component.exports